const qs = require("qs")
const moment = require("moment")

const snilsText = $('#snils-input')
const acPeriodSelector = $('#period-selector')
const acTenantSelector = $('#ac-tenant-selector')

const queryParams = qs.parse(window.location.search?.replace('?', '')) || {}
if (queryParams.snils) snilsText.val(queryParams.snils)
if (queryParams.period) acPeriodSelector.val(queryParams.period)
if (queryParams.tenant) acTenantSelector.val(queryParams.tenant)
if (queryParams.from && queryParams.to) {
  $('#datepicker-from').val(queryParams.from)
  $('#datepicker-to').val(queryParams.to)
}

function setQueryParams(params) {
  const queryParams = qs.parse(window.location.search?.replace('?', '')) || {}
  const newQuery = qs.stringify({ ...queryParams, ...params }, { arrayFormat: 'brackets' })
  window.history.replaceState(window.history.state, null, `?${newQuery}`) // у турболинков ломается возврат, если затереть стейт
}

function updateDatepicker(from, to) {
  $('#datepicker-from').datepicker('update', from?.toDate())
  $('#datepicker-to').datepicker('update', to?.toDate())
  setQueryParams({ from: from?.format('DD.MM.YYYY'), to: to?.format('DD.MM.YYYY')})
}

snilsText.change(() => {
  setQueryParams( { snils: snilsText.val() })
})

acTenantSelector.change(() => {
  setQueryParams({ tenant: acTenantSelector.val() })
})

acPeriodSelector.change(() => {
  const now = moment()
  switch (acPeriodSelector.val()) {
    case 'day':
      updateDatepicker(moment(now).startOf('day'), now)
      break

    case 'month':
      updateDatepicker(moment(now).startOf('month'), now)
      break

    case 'quarter':
      updateDatepicker(moment(now).startOf('quarter'), now)
      break

    case 'semester':
      updateDatepicker(moment([now.year(), now.month() < 6 ? 0 : 6]), now)
      break

    case 'year':
      updateDatepicker(moment(now).startOf('year'), now)
      break

    case 'all':
      updateDatepicker()
  }
  setQueryParams({ period: acPeriodSelector.val() })
})

$('.input-daterange').on('changeDate', (e) => {
  const date = moment(e.date).format('DD.MM.YYYY')
  if (e.target.id === 'datepicker-from') {
    setQueryParams({ from: date})
  } else if (e.target.id === 'datepicker-to') {
    setQueryParams({ to: date })
  }
  setQueryParams({ period: 'custom' })
})

$('#checking-auth').click(() => {
  document.location.reload()
})

window.addEventListener('load', () => {
  if (document.getElementsByClassName('auth-confirmation-page')[0]) {
    setQueryParams({ from: $('#datepicker-from').val(), to: $('#datepicker-to').val() })
  }
})

document.addEventListener('turbolinks:load', () => {
  if (document.getElementsByClassName('auth-confirmation-page')[0]) {
    setQueryParams({ from: $('#datepicker-from').val(), to: $('#datepicker-to').val() })
  }
})
